import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'antd'

import { icons, ColourButton, Spacer, Label } from 'portal/lib/primitives'

export function RemoveButton({
  children = 'Remove',
  iconOnly = false,
  ...props
}) {
  if (iconOnly) {
    return (
      <Tooltip title={children}>
        <ColourButton.Negative
          id="RemoveButton"
          style={{ padding: '4px 8px' }}
          {...props}
        >
          <icons.TrashCan colour="currentColor" />
        </ColourButton.Negative>
      </Tooltip>
    )
  }

  return (
    <ColourButton.Negative id="RemoveButton" {...props}>
      <icons.TrashCan colour="currentColor" />

      <Spacer.Fine />

      <Label isChild colour="inherit">
        {children}
      </Label>
    </ColourButton.Negative>
  )
}

RemoveButton.propTypes = {
  ...ColourButton.Negative.propTypes,
  children: PropTypes.string
}
